import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Button, Col, DatePicker, Form, Input, Row, Switch } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import dayjs from 'dayjs';
import { Container } from 'reactstrap';
import { createEntity, getEntity, updateEntity } from '../plan-period.reducer';

export const PlanPeriodUpdate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { planPeriodType } = location.state || {};
  const [form] = Form.useForm();
  const { id } = useParams();
  const isNew = id === undefined;

  const planPeriodEntity = useAppSelector(state => state.planPeriod.entity);
  const updating = useAppSelector(state => state.planPeriod.updating);
  const updateSuccess = useAppSelector(state => state.planPeriod.updateSuccess);

  const handleClose = () => {
    form.resetFields();
    navigate('/plan-period');
  };

  useEffect(() => {
    innitData();
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (planPeriodEntity && !isNew) {
      form.setFieldsValue({
        ...planPeriodEntity,
        startDate: dayjs(planPeriodEntity.startDate),
        endDate: dayjs(planPeriodEntity.endDate),
      });
    }
  }, [planPeriodEntity]);

  const innitData = () => {
    // get detail
    if (isNew) {
      form.resetFields();
    } else {
      dispatch(getEntity(id));
    }
  };

  const handleSubmit = values => {
    const type = !isNew ? planPeriodEntity?.planPeriodType : planPeriodType;
    const entity = {
      ...planPeriodEntity,
      ...values,
      planPeriodType: type,
      startDate: dayjs(values.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      endDate: dayjs(values.endDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
    };
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Container className="form">
      <Form size="large" form={form} initialValues={{ isEnabled: true }} onFinish={handleSubmit} layout="vertical">
        <Title level={3}>{`${id ? 'Cập nhật thông tin' : 'Thêm mới'} kỳ kế hoạch`}</Title>
        <Row>
          <Col md={7}>
            <Form.Item label="Tên kỳ kế hoạch" rules={[{ required: true, message: 'Hãy nhập tên kỳ kế hoạch' }]} name="name">
              <Input className="w-100" size="large" placeholder="Nhập tên kỳ kế hoạch" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={7}>
            <Form.Item label="Ngày bắt đầu" rules={[{ required: true, message: 'Hãy chọn ngày bắt đầu' }]} name="startDate">
              <DatePicker className="w-100" format={APP_LOCAL_DATE_FORMAT} placeholder="Chọn ngày bắt đầu" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={8}>
            <Form.Item label="Ngày kết thúc" rules={[{ required: true, message: 'Hãy chọn ngày kế thúc' }]} name="endDate">
              <DatePicker className="w-100" format={APP_LOCAL_DATE_FORMAT} placeholder="Chọn ngày kế thúc" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Form.Item label="Ghi chú" name={'note'}>
              <TextArea placeholder="Nhập ghi chú" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Form.Item label="Tình trạng" name={'isEnabled'}>
              <Switch checkedChildren="Mở" unCheckedChildren="Đóng" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="action mt-3" justify="end">
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={updating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default PlanPeriodUpdate;
